"use strict";
/* --------------------------------------------------------------------------------------------
 *  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGlobalInstaller = void 0;
const path = require("path");
const crypto = require("crypto");
class IGlobalInstaller {
    constructor(acquisitionContext, utilContext) {
        this.acquisitionContext = acquisitionContext;
        this.utilityContext = utilContext;
    }
    /**
     *
     * @returns The folder where global sdk installers will be downloaded onto the disk.
     */
    static getDownloadedInstallFilesFolder(uniqueInstallerId) {
        return path.join(__dirname, 'installers', crypto.createHash('sha256').update(uniqueInstallerId).digest('hex'));
    }
}
exports.IGlobalInstaller = IGlobalInstaller;
//# sourceMappingURL=IGlobalInstaller.js.map